import ApiBase from "../../../services/ApiBase"

export default class Api {
    static groupPermissions(query) {
        return ApiBase.groupPermissions(query).then((resp) => {
            return resp.data
        })
    }
}
